import {useEffect, useState} from 'react';
import {useMutation} from '@apollo/react-hooks';
import {validacion, defaults, dev} from 'lib.common';

const {esVarNullUndef} = validacion;
const {funcionVacia} = defaults;

export default function useApolloM(
   query,
   {
      callbackProcesarData = funcionVacia,
      callbackError = funcionVacia,
      callbackLoading = funcionVacia
   } = {},
   apolloOptions = {}
) {
   const [dsVariables, setDsVariables] = useState(null);
   function onCompleted(data) {
      if (!esVarNullUndef(data)) {
         callbackProcesarData(data, dsVariables);
      }
      setDsVariables(null);
   }

   function onError(error) {
      let eMsg = '';
      if (!esVarNullUndef(error)) {
         eMsg = eMsg + dev.getErrorMsg(error);
      }
      if (eMsg !== '') {
         callbackError(eMsg);
      }
      setDsVariables(null);
   }

   const [mutateDataApollo, {data, loading, called, error, ...apolloResult}] = useMutation(query, {
      ...apolloOptions,
      onCompleted,
      onError
   });
   async function mutateData(apolloProps, extraData = null) {
      setDsVariables(extraData);
      return mutateDataApollo(apolloProps);
   }

   useEffect(() => {
      callbackLoading(loading);
   }, [loading]);

   return [mutateData, {data, loading, called, error, ...apolloResult}];
}
